import { Input, OnInit, ViewChild, EventEmitter, Output, ChangeDetectorRef, Directive } from '@angular/core';
import { AppDataListDirective } from '../../directive/app-data-list.directive';
import { Observable } from 'rxjs';
import { KeyValue } from '@app/shared/model/keyValue.model';

@Directive()
export abstract class AbstractDataListComponent implements OnInit {

    // ********************** propiedades del componente *********************

    // para clave
    @Input() appServerSearchValue?: boolean;                // si se va a buscar por clave
    @Input() appNumberTypeValueServerSearch?: number;       // número de caracteres para empezar a filtrar por clave
    // para código
    @Input() appServerSearchKey?: boolean;                  // si se va a buscar por código
    @Input() appNumberTypeKeyServerSearch?: number;         // número de caracteres para empezar a filtrar por codigo
    // resto
    @Input() appInputId: string;                            // iD DEL INPUT
    @Input() appShowValue?: boolean;                        // si va a mostrar key y value
    @Input() appEntity?: string;                            // entidad a buscar
    @Input() appURLKeySearchService?: string;               // URL del servicio de busqueda por clave
    @Input() appURLValueSearchService?: string;             // URL des servicio de busqueda por valor
    @Input() appId: string;                                 // id del data-list
    @Input() appMulti = false;                                 // si es para multi-seleccion

    // ********************** Metodos de componente padre ********************

    @Output() appElementNotFoundMethod = new EventEmitter<any>(); // metodo padre para cuando no encuentra el elemnto
    @Output() appErrorMethod = new EventEmitter<any>();           // metodo si se produce un error

    // ********************** propiedades de ayuda ***************************

    // para la tabla gestionada por angular
    // directiva de tabla customizada
    @ViewChild(AppDataListDirective)
    private appDataList: AppDataListDirective;

    // listado de objetos de data list con los paises
    public elements: Array<KeyValue> = [];
    // public elementsAll: Array<KeyValue> = [];

    public isEntity = true;

    public preValue = '';

    // ********************** Constructor ***********************************

    constructor(
        public changeDetector: ChangeDetectorRef,
        private maxOptions: number
    ) {
    }

    // ********************** Metdodos de ciclo de vida ********************
    ngOnInit(): void {
        this.propertyInit();
    }

    // ********************** Metdodos de ayuda ****************************

    // inicio de la directiva
    propertyInit(): void {

        // inicio de las variables
        if (this.appServerSearchKey === undefined || this.appServerSearchKey === null ) {
            this.appServerSearchKey = false;
        }
        if (this.appNumberTypeKeyServerSearch === undefined || this.appNumberTypeKeyServerSearch === null ) {
            this.appNumberTypeKeyServerSearch = 1;
        }
        if (this.appServerSearchValue === undefined || this.appServerSearchValue === null ) {
            this.appServerSearchValue = false;
        }
        if (this.appNumberTypeValueServerSearch === undefined || this.appNumberTypeValueServerSearch === null ) {
            this.appNumberTypeValueServerSearch = this.appNumberTypeKeyServerSearch + 3;
        }
        if (this.appShowValue === undefined || this.appShowValue === null ) {
            this.appShowValue = true;
        }
        if (this.appId === undefined || this.appId === null ) {
            throw new TypeError('the input <appId> is required');
        }
        if (this.appInputId === undefined || this.appInputId === null ) {
            throw new TypeError('the input <appInputId> is required');
        }
        if (this.appServerSearchValue === true && this.appShowValue === false ) {
            throw new TypeError('the input <appShowValue> must be true if <appServerSearchValue> is true');
        }

        if (this.appEntity === undefined || this.appEntity === null ) {
            this.isEntity = false;
            if ((this.appURLKeySearchService === undefined || this.appURLKeySearchService === null) &&
                this.appServerSearchKey === true) {
                throw new TypeError('the input <appURLKeySearchService> or <appEntity> is required');
            }
            if ((this.appURLValueSearchService === undefined || this.appURLValueSearchService === null) &&
                this.appServerSearchValue === true) {
                throw new TypeError('the input <appURLValueSearchService> or <appEntity> is required');
            }
        } else {
            this.isEntity = true;
        }


    }


    // ********************** Metdodos y funciones de controlador **************

    public searchKey(search: {value: string; preValue: string}): void {
        // this.appDataList.setLoadState(true);
        try {
            this.preValue = search.preValue;
            this.keySearchData(search.value);
        } catch (error) {
            // this.setHelpText('No help options');
        }
    }

    public searchValue(search: {value: string; preValue: string}): void {
        // this.appDataList.setLoadState(true);
        try {
            this.preValue = search.preValue;
            this.valueSearchData(search.value);
        } catch (error) {
            // this.setHelpText('No help options');
        }
    }

    public removeDataList(): void {
        this.elements = [];
        if (this.changeDetector) {
            this.changeDetector.detectChanges();
        }
    }

    // ********************** Metdodos y funciones internas ********************

    protected isMethodEnabled(event: EventEmitter<any>): boolean {
        if (event.observers.length === 0) {
            return false;
        } else {
            return true;
        }
    }

    // ********************** Metdodos y funciones llamadas desde el hijo *******

    protected searchResponse(elements: Array<KeyValue>): void {
        console.log('Prueba');
        if (elements === null || elements.length === 0) {
            // this.setHelpText('No help options');
        } else {
            if (this.maxOptions < elements.length) {
                this.elements = elements.slice(0, this.maxOptions);
            } else {
                this.elements = elements;
            }
            if (this.changeDetector) {
                this.changeDetector.detectChanges();
            }
        }
    }

    protected searchObservableSubscribe(observable: Observable<KeyValue[]>, value: string, endMethod?: () => void): void {

        observable.subscribe({
            next: elements => {
              // si todo ha ido bien
              // llamamos al metodo de devolución de los datos
              this.searchResponse(elements);
              if (endMethod) {
                  endMethod();
              }
            },
            error: (err) => {
              // si ha dado error
              // pintamos en la consola
              console.log('HTTP response error', err);
              this.elements = [];
              if (this.changeDetector) {
                this.changeDetector.detectChanges();
              }
            }
        });
    }

    // ********************** Metdodos y funciones abstractos ******************

    abstract keySearchData(key: string): void;
    abstract valueSearchData(value: string): void;
    // abstract elementNotFound(value: string): void;

}
